module.exports = {
    // document title
    Title: "超强伟业",

    CDN: 'https://cdn.gatesstsuperlaser.com',

    tokenExpires: 2592000000 // 30 days
};
